module.exports = __webpack_public_path__ + "img/news14_6.4d358adf.jpg";